export default "skymp5-front/4c2efb194cb4d9fd88b8b855775de2cb.gif";